import React from 'react'
import PropTypes from 'prop-types'
import { AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES } from '../../data/constants'
import { getSubsectionView } from '../../data/scoring'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import WhyThisMatters from '../../components/WhyThisMatters/WhyThisMatters'
import ConditionalAccess from './ConditionalAccess'
import Device from './Device'
import GlobalAdmins from './GlobalAdmins'
import Mfa from './Mfa'

export default function IdentityAccess({ summary = {}, data = {}, scoring = { sections: [] }, dataAvailability = [] }) {
  const globalAdmins = getSubsectionView(scoring, 'globalAdmins')
  const conditionalAccess = getSubsectionView(scoring, 'conditionalAccess')
  const mfa = getSubsectionView(scoring, 'mfa')

  return (
    <>
      <div {...AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES}>
        <SectionHeading
          id="identity-access"
          titleId="AI_RISK_REPORT.SECTION.IDENTITY.TITLE"
          questionId="AI_RISK_REPORT.SECTION.IDENTITY.QUESTION"
        />
        <WhyThisMatters bodyId="AI_RISK_REPORT.SECTION.IDENTITY.WHY" />
      </div>
      <GlobalAdmins
        admins={data.globalAdmins ?? []}
        score={globalAdmins.score}
        controls={globalAdmins.controls}
        gap={globalAdmins.gap}
        summary={summary}
      />
      <ConditionalAccess
        score={conditionalAccess.score}
        gap={conditionalAccess.gap}
        summary={summary}
        baselines={data.conditionalAccessBaselines ?? []}
      />
      <Mfa summary={summary} mfaUsers={data.mfaUsers ?? { total: 0, items: [] }} score={mfa.score} gap={mfa.gap} />
      <Device dataAvailability={dataAvailability} />
    </>
  )
}

const summaryPropType = PropTypes.shape({
  users: PropTypes.shape({
    total: PropTypes.number,
    globalAdmins: PropTypes.number,
    mfa: PropTypes.shape({
      assessed: PropTypes.number,
      registered: PropTypes.number,
      registeredPct: PropTypes.number,
      nonPhishingResistantCount: PropTypes.number,
    }),
  }),
  conditionalAccess: PropTypes.shape({
    total: PropTypes.number,
    enabled: PropTypes.number,
    reportOnly: PropTypes.number,
    enabledPct: PropTypes.number,
  }),
})

IdentityAccess.propTypes = {
  summary: summaryPropType,
  data: PropTypes.shape({
    globalAdmins: PropTypes.arrayOf(PropTypes.shape({})),
    mfaUsers: PropTypes.shape({
      total: PropTypes.number,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    conditionalAccessBaselines: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  scoring: PropTypes.shape({ sections: PropTypes.arrayOf(PropTypes.shape({})) }),
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
}
